import { render, staticRenderFns } from "./MediaText.vue?vue&type=template&id=3fd261e4&lang=pug"
import script from "./MediaText.vue?vue&type=script&lang=ts"
export * from "./MediaText.vue?vue&type=script&lang=ts"
import style0 from "./MediaText.vue?vue&type=style&index=0&id=3fd261e4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OptimizedImage: require('/app/components/generic/OptimizedImage.vue').default,Block: require('/app/components/generic/Block.vue').default})
